import { create } from 'zustand';

import type { Config } from '../config.schema';

export type AppConfig = {
  portals?: {
    'travel-time'?: string;
    'travel-locations'?: string;
    'route-comparison'?: string;
    'route-step-by-step'?: string;
    'map-view'?: string;
    'how-it-works'?: string;
    'route-selection'?: string;
    legal?: string;
  };
  config?: Config;
  setPortals: (portals: Partial<AppConfig['portals']>) => void;
  setConfig: (config: Config | undefined) => void;
  isMapExpanded: boolean;
  setMapExpanded: (expanded: boolean) => void;
};

export const useConfigStore = create<AppConfig>((set) => ({
  portals: {},
  config: undefined,
  setPortals: (portals: Partial<AppConfig['portals']>) =>
    set((state) => ({
      portals: { ...state.portals, ...portals },
    })),
  setConfig: (config: Config | undefined) => set({ config }),
  isMapExpanded: false,
  setMapExpanded: (expanded: boolean) => set({ isMapExpanded: expanded }),
}));
